import { GlobalProvider } from './contexts/GlobalProvider';
import { Switchboard } from './routes/Switchboard/Switchboard';
import { PublicMenuEntry } from './pages/DigitalMenuPage/PublicMenuEntry';
import { PublicAttendanceEntry } from './pages/PublicAttendancePage/PublicAttendancePage';

export const App = () => window.location.pathname.startsWith('/attendance/') ? <PublicAttendanceEntry /> : window.location.pathname.startsWith('/menu/') ? <PublicMenuEntry /> : (
    <GlobalProvider>
        <Switchboard />
    </GlobalProvider>
);
